<div class="pcl-container">

  <!-- Loading -->
  <div *ngIf="loading" class="pcl-loading">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Loading checklists…</span>
  </div>

  <ng-container *ngIf="!loading">

    <!-- Empty state -->
    <div *ngIf="templateStates.length === 0" class="pcl-empty">
      <i class="pi pi-list-check pcl-empty-icon"></i>
      <p>No checklist templates configured.</p>
      <p class="pcl-empty-sub">An admin can add templates under Settings → Process Check List.</p>
    </div>

    <!-- Template accordion panels -->
    <div *ngFor="let state of templateStates" class="pcl-template-panel"
      [class.pcl-template-panel--expanded]="state.expanded"
      [class.pcl-template-panel--inactive]="!state.template.isActive">

      <!-- Panel header (click to expand) -->
      <div class="pcl-panel-header" (click)="toggleExpand(state)">
        <div class="pcl-panel-left">
          <button class="pcl-expand-btn" type="button"
            [attr.aria-expanded]="state.expanded"
            [attr.aria-label]="state.expanded ? 'Collapse' : 'Expand'">
            <i [class]="state.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
          </button>
          <div class="pcl-panel-info">
            <span class="pcl-template-name">{{ state.template.name }}</span>
          </div>
        </div>
        <div class="pcl-panel-right">
          <span class="pcl-item-count">
            {{ state.rows.length }} item{{ state.rows.length !== 1 ? 's' : '' }}
          </span>
          <span *ngIf="state.isDirty" class="pcl-unsaved-badge">Unsaved</span>
          <p-button
            *ngIf="state.isDirty"
            label="Save"
            icon="pi pi-save"
            severity="primary"
            size="small"
            [loading]="state.saving"
            (onClick)="saveTemplate(state); $event.stopPropagation()" />
        </div>
      </div>

      <!-- Panel body -->
      <div *ngIf="state.expanded" class="pcl-panel-body">

        <div *ngIf="state.rows.length === 0" class="pcl-items-empty">
          <i class="pi pi-inbox"></i>
          <span>No items in this checklist.</span>
        </div>

        <div *ngIf="state.rows.length > 0" class="pcl-table-wrapper">
          <table class="pcl-table">
            <thead>
              <tr>
                <th class="pcl-col-num">#</th>
                <th class="pcl-col-name">Check List Item</th>
                <th class="pcl-col-answer">Selection</th>
                <th class="pcl-col-comment">Comment</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of state.rows; let i = index"
                class="pcl-row"
                [class.pcl-row--inactive]="!row.isActive"
                [class.pcl-row--yes]="row.isActive && row.answer === 'Yes'"
                [class.pcl-row--no]="row.isActive && row.answer === 'No'"
                [class.pcl-row--na]="row.isActive && row.answer === 'NA'">

                <td class="pcl-col-num">
                  <span class="pcl-row-index" [class.pcl-row-index--inactive]="!row.isActive">{{ i + 1 }}</span>
                </td>

                <td class="pcl-col-name">
                  <div class="pcl-item-name">{{ row.question }}</div>
                  <span *ngIf="!row.isActive" class="pcl-inactive-badge"
                    pTooltip="This item has been deactivated by admin"
                    tooltipPosition="top">Inactive</span>
                </td>

                <td class="pcl-col-answer">
                  <p-select
                    *ngIf="row.isActive"
                    [(ngModel)]="row.answer"
                    [options]="answerOptions"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    panelStyleClass="filter-dropdown-panel"
                    styleClass="pcl-answer-select"
                    [ngClass]="{
                      'pcl-ans-yes': row.answer === 'Yes',
                      'pcl-ans-no': row.answer === 'No',
                      'pcl-ans-na': row.answer === 'NA'
                    }"
                    (onChange)="onAnswerChange(state)" />
                  <span
                    *ngIf="!row.isActive && row.answer"
                    class="pcl-readonly-answer"
                    [ngClass]="{
                      'pcl-ans-yes': row.answer === 'Yes',
                      'pcl-ans-no': row.answer === 'No',
                      'pcl-ans-na': row.answer === 'NA'
                    }">{{ row.answer }}</span>
                  <span *ngIf="!row.isActive && !row.answer" class="pcl-readonly-answer pcl-ans-empty">—</span>
                </td>

                <td class="pcl-col-comment">
                  <textarea
                    *ngIf="row.isActive"
                    [(ngModel)]="row.comment"
                    (ngModelChange)="onAnswerChange(state)"
                    class="p-inputtext pcl-comment-input"
                    [class.pcl-comment-error]="row.answer === 'No' && !row.comment.trim()"
                    rows="1"
                    [placeholder]="row.answer === 'No' ? 'Comment required for No…' : 'Add a note…'"></textarea>
                  <span *ngIf="row.isActive && row.answer === 'No' && !row.comment.trim()" class="pcl-comment-required-hint">
                    * Comment is required
                  </span>
                  <span *ngIf="!row.isActive" class="pcl-readonly-comment">{{ row.comment || '—' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </ng-container>
</div>
